import React, { createContext, useState, useEffect, useContext } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { jwtDecode as jwt_decode } from "jwt-decode";
import { renewSession } from "../funciones_utiles";

const SesionContext = createContext();

export const SesionProvider = ({ children }) => {
  const token = localStorage.getItem("camulabo_valid_session");
  let decoded;
  
  if (token === "undefined" || token === null) {
    window.location.href = "/";
    localStorage.removeItem("camulabo_valid_session");
  } else {
    decoded = jwt_decode(token);
  }
//   console.log(decoded)
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [sesion, setSesion] = useState({
        dni:decoded.objetoSession.dni,
		email:decoded.objetoSession.email,
		nombre:decoded.objetoSession.nombre,
		apellido:decoded.objetoSession.apellido,
		telefono:decoded.objetoSession.telefono,
		obra_social:decoded.objetoSession.obra_social,
		direccion:decoded.objetoSession.direccion,
        contrasenia:decoded.objetoSession.dniEqualsPassword,
        pre_cambio:decoded.objetoSession.existsInPreCambio
  });
//   dni,
//   email,
//   nombre,
//   apellido,
//   telefono,
//   obra_social,
//   direccion
  useEffect(() => {
    const renewSessionPeriodically = () => {
      renewSession()
        .then(() => {
          const token = localStorage.getItem("camulabo_valid_session");
          if (token === "undefined" || token === null) {
            window.location.href = "/";
            localStorage.removeItem("camulabo_valid_session");
          } else {
            const decoded = jwt_decode(token);
            // console.log(decoded)
            setSesion({
                dni:decoded.objetoSession.dni,
                email:decoded.objetoSession.email,
                nombre:decoded.objetoSession.nombre,
                apellido:decoded.objetoSession.apellido,
                telefono:decoded.objetoSession.telefono,
                obra_social:decoded.objetoSession.obra_social,
                direccion:decoded.objetoSession.direccion,
                contrasenia:decoded.objetoSession.dniEqualsPassword,
                pre_cambio:decoded.objetoSession.existsInPreCambio
            });
          }
        })
        .catch((error) => {
          console.error("Error al renovar la sesión:", error);
        });
    };
    renewSessionPeriodically();
    // Renueva la sesión cada 5 minutos (300000 ms)
    const intervalId = setInterval(renewSessionPeriodically, 300000);

    return () => clearInterval(intervalId); // Limpia el intervalo al desmontar
  }, [location.pathname]);

  return (
    <SesionContext.Provider value={{ sesion }}>
      {children}
    </SesionContext.Provider>
  );
};

export const useSesion = () => useContext(SesionContext);